import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import UserMixin from "@/mixins/UserMixin";
import MongoServiceMixin from "@/mixins/MongoServiceMixin";
import "./styles/main.scss";
import authClient from "@/auth/authClient";
import RouteNames from "./router/RouteNames";

Vue.config.productionTip = false;

Vue.mixin(UserMixin);
Vue.mixin(MongoServiceMixin);

const rootState = { user: authClient.currentUser(), auth: authClient };

router.beforeEach((to, _from, next) => {
  if (!rootState.user && to.name !== RouteNames.HOME) {
    next({ name: RouteNames.HOME });
  } else {
    next();
  }
});

new Vue({
  vuetify,
  router,
  render: (h) => h(App),
  data: () => {
    return rootState;
  },
}).$mount("#app");
